import MapBox from '../services/MapBox'

export default {
    name: 'bigMap',
    props: {
      siteName: String
    },
    data() {
      return {
        breadcrumb: []
      }
    },
    created() {
    },
    async mounted() {
      await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
      this.buildMap();
  
      // Build breadcrumb
      this.breadcrumb = [
        {
          text: this.siteName,
          disabled: false,
          href: '/'
        },
        {
          text: 'map',
          disabled: true
        }
      ];
    },
    methods: {
      async buildMap() {    
          let map = MapBox.createMap();
  
          map.on('load', () => {
              map.fitBounds([[-73.3429071, 45.0107152], [-72.4583276, 42.7288618]], { padding: 10, duration: 0 });
  
              // Class 4
              map.addLayer({
                  'id': 'class4',
                  'type': 'line',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/class4-roads.geojson'
                  },
                  'paint': {
                      'line-color': '#ba671e',
                      'line-width': 3,
                      'line-opacity': .5
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              map.addLayer({
                  'id': 'towns',
                  'type': 'fill',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/Vermont-Town-Boundaries.geojson'
                  },
                  'paint': {
                      'fill-color': 'rgba(200, 100, 240, 0.2)',
                      'fill-outline-color': 'rgba(200, 100, 240, 1)'
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              // Gravel
              map.addLayer({
                  'id': 'gravel',
                  'type': 'line',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/gravel.geojson'
                  },
                  'paint': {
                      'line-color': '#06D6A0',
                      'line-width': 3,
                      'line-opacity': .5
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              // Dirt
              map.addLayer({
                  'id': 'dirt',
                  'type': 'line',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/dirt.geojson'
                  },
                  'paint': {
                      'line-color': '#118AB2',
                      'line-width': 3,
                      'line-opacity': .5
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              // Primitive
              map.addLayer({
                  'id': 'primitive',
                  'type': 'line',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/primitive.geojson'
                  },
                  'paint': {
                      'line-color': '#FFD166',
                      'line-width': 3,
                      'line-opacity': .5
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              // Impassable
              map.addLayer({
                  'id': 'impassable',
                  'type': 'line',
                  'source': {
                      'type': 'geojson',
                      'data': 'https://vermont-class-4-map.s3.amazonaws.com/assets/impassable.geojson'
                  },
                  'paint': {
                      'line-color': '#EF476F',
                      'line-width': 3,
                      'line-opacity': .5
                  },
                  'layout': {
                      'visibility': 'none'
                  }
              });
  
              map.on('click', 'towns', async (data) => {
                  let town = data.features[0].properties.TOWNNAMEMC;
  
                  try {
                      let townUrlPart = town.toLowerCase().replace(/ /g,'-').replace(/\./g,'');
                      let html = `${town}<br />`;
                      html+=`<a href='./towns/${townUrlPart}'>View Roads</a>`;
  
                      new mapboxgl.Popup()
                      .setLngLat(data.lngLat)
                      .setHTML(html)
                      .addTo(map);
                  } catch (err) {
                      //console.dir(err);
                  }
              });
          });
  
          const toggleableLayerIds = ['class4','gravel', 'dirt', 'primitive', 'impassable', 'towns' ];
          var layers = document.getElementById('menu');
  
          for (let i = 0; i < toggleableLayerIds.length; i++) {
              var id = toggleableLayerIds[i];
              
              let link = document.createElement('a');
              link.href = '#';
              link.className = '';
              link.textContent = id;
              
              link.onclick = function (e) {
                  var clickedLayer = this.textContent;
                  e.preventDefault();
                  e.stopPropagation();
              
                  var visibility = map.getLayoutProperty(clickedLayer, 'visibility');
                  
                  if (visibility === 'visible') {
                      map.setLayoutProperty(clickedLayer, 'visibility', 'none');
                      this.className = '';
                  } else {
                      this.className = 'active-'+clickedLayer;
                      map.setLayoutProperty(clickedLayer, 'visibility', 'visible');
                  }
              };
              layers.appendChild(link);
          }
      }
    }
  }